import React from "react";
import axios from "axios";
import _ from "lodash";
import AggregateFilters from "./aggregate_filters";
import Products from "./products";
import UrlManagement from "./../../shared/url_management";
import logo from "./../../shared/logo.svg";

class ProductListings extends React.Component {
  constructor(props) {
    super(props);
    this.url = new UrlManagement();
    this.state = {
      results: [],
      filters: [],
      aggs: [],
      no_results: false,
      loading: true,
      title: "",
      viewFiltersText: "View Filters"
    };
    this.tryAgain = this.tryAgain.bind(this);
    this.search = this.search.bind(this);
    this.toggleFilters = this.toggleFilters.bind(this);
  }
  componentDidMount() {
    this.search();
    window.onpopstate = () => {
      this.search();
    };
    if (_.includes(_.keys(this.url.getParsedUrl()), "q")) {
      this.setState({
        search_term: this.url.getParsedUrl()["q"]
      });
    }
  }
  tryAgain() {
    this.setState({
      error: false,
      loading: true
    });
    this.search();
  }
  search(filters, size) {
    this.setState({ loading: true });
    PubSub.publish("COMPARE_UPDATED", "search triggered");
    let fs = [];
    if (fs.length === 0) {
      this.setState({
        blank_filters: true
      });
    }

    _.forEach(this.url.getParsedUrl(), (p, v) => {
      let f = {};
      f["agg"] = v;
      f["filter"] = p;
      fs.push(f);
    });

    var query = "";

    if (!_.isEmpty(fs)) {
      this.setState({
        blank_filters: false
      });
      _.each(fs, filter => {
        query += `&${filter.agg}[]=${filter.filter}`;
      });
    }

    if (size) {
      query += `&toSearch=${size}`;
    }

    axios
      .get(`/product_listings/search?${query}`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      })
      .then(response => {
        // We have no results, lets show everything
        if (response.data.results.length === 0) {
          this.url.clearUrl();
          this.setState({
            no_results: true
          });
          this.search();
        }

        const aggs = [];

        let categoryAggs = {};
        categoryAggs.title = "Category";
        categoryAggs.agg_type = "category";
        categoryAggs.values = [];

        _.each(response.data.aggs.categories.buckets, (details, key) => {
          if (_.isObject(details)) {
            categoryAggs.values.push({
              key: details.key.replace(/[0-9]/g, "").trim(),
              count: details.doc_count
            });
          }
        });

        aggs.push(categoryAggs);

        _.each(response.data.aggs.specification, (details, key) => {
          if (_.isObject(details)) {
            let agg = {};

            if (details.buckets.length > 0) {
              agg.title = key
                .replace("_", " ")
                .replace(/\b\w/g, l => l.toUpperCase());
              agg.agg_type = key;
              agg.values = [];
            }
            _.each(details.buckets, bucket => {
              agg.values.push({ key: bucket.key, count: bucket.doc_count });
            });

            if (!_.isEmpty(agg)) {
              aggs.push(agg);
            }
          }
        });

        this.setState({
          aggs,
          results: response.data.results,
          total: response.data.aggs.specification.doc_count,
          title: aggs[0].values[0].key
        });

        setTimeout(() => {
          this.setState({
            loading: false
          });
        }, 500);
      })
      .catch(() => {});
  }

  toggleFilters() {
    const filters = document.querySelector(".filters");
    filters.classList.toggle("filters--visible");
    document.body.classList.toggle("no-scroll");
  }

  render() {
    if (this.state.error != true) {
      return (
        <div>
          {this.state.title &&
          this.state.search_term === undefined &&
          this.state.blank_filters === false ? (
            <div
              className={`search-term search-term__${this.state.title
                .toLowerCase()
                .replace(/[^A-Z0-9]/gi, "")}`}
            >
              <i className="search-term__icon" />
              <h1>{this.state.title}</h1>
            </div>
          ) : (
            ""
          )}
          {this.state.blank_filters && this.state.no_results === false ? (
            <div className="search-term">
              <h1>All Products</h1>
            </div>
          ) : (
            ""
          )}
          {this.state.search_term && this.state.blank_filters === false ? (
            <div className="search-term">
              Search Results for <h1>&quot;{this.state.search_term}&quot;</h1>
            </div>
          ) : (
            ""
          )}
          {this.state.no_results ? (
            <div className="search-term search-term--no-results">
              We found no results for your search, so we're showing you all our
              products
            </div>
          ) : (
            ""
          )}
          {this.state.loading ? (
            <div className="loading">
              <img src={logo} />
              <h2>Loading Products</h2>
              <div className="loader-inner ball-pulse">
                <div />
                <div />
                <div />
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="product-listings__content">
            <div className="filters__toggle-btn" onClick={this.toggleFilters}>
              {this.state.viewFiltersText}
            </div>
            <AggregateFilters
              aggs={this.state.aggs}
              handleSearch={this.search}
            />
            <Products
              title={this.state.title}
              results={this.state.results}
              total={this.state.total}
              handleSearch={this.search}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div className="siteError">
          <i className="material-icons">info</i>
          Sorry, there has been an error retrieving your products{" "}
          <a href="#" onClick={this.tryAgain}>
            try again
          </a>
        </div>
      );
    }
  }
}

export { ProductListings as default };
